export const downloadFile = (blob, fileName, fileType) => {
    console.log('Logging blob before downloading', blob);
    if (window.navigator.msSaveOrOpenBlob) {
        if (fileType === null) {
            window.navigator.msSaveOrOpenBlob(blob, `${fileName}`);
        } else {
            window.navigator.msSaveOrOpenBlob(blob, `${fileName}.${fileType}`);
        }
        // Ler IE handle download
    } else {
        // Create Object URL
        var objectURL = URL.createObjectURL(blob);

        //Create Anchor DOM Element
        var link = document.createElement('a');

        // Assign Object URL to created anchor
        link.href = objectURL;

        // Give String which will be used as File Name
        if (fileType === null) {
            link.download = `${fileName}`;
        } else {
            link.download = `${fileName}.${fileType}`;
        }

        link.click();
    }
};
